/**
 * Zjednodušený popis chyby při načítání dat ze serveru.
 */
import { ApiError, ApiErrorIntent } from './standardErrorInterceptor';

export type LoadDataApiError = {
  // Zpráva chyby
  message: string;
  // Podrobnosti o chybě
  description?: string;
  // Závažnost chyby
  intent: ApiErrorIntent;
  // Příčina chyby - pokud nastala chyba na severu
  apiError?: ApiError;
  // Příčina chyby JS na klientovi, pokud nastala při zpracování odpověd ze serveru
  jsError?: any;
};

/**
 * Extrakce chyby načítání dat. Je vhodné na zobazení informace o chybě načítání někde na stránce, pro rozlišení zda volat toaster apod. není vhodné, výstupem této metody je naparsování chybných textů do lepší struktury.
 *
 * @param _error obecná chyba
 * @return naparsovaná chyba načítání dat
 */
export function getLoadDataError(_error: any): LoadDataApiError {
  if (_error.stack && _error.message) {
    console.error(_error);

    let result: LoadDataApiError = {
      message: 'Nastala chyba při zpracování načtených dat',
      intent: ApiErrorIntent.DANGER,
      jsError: _error,
    };
    return result;
  } else {
    const error = _error as ApiError;
    // Request byl programově přerušen
    if (error.cancelled) {
      let result: LoadDataApiError = {
        message: 'Požadavek byl přerušen',
        description: error.responseError.message,
        intent: ApiErrorIntent.WARNING,
        apiError: _error,
      };

      return result;
    } else {
      switch (error.status) {
        case 422:
          {
            const { _error, ...rest } = error.formErrors;
            const errObj = {
              ...rest,
            };
            if (_error) {
              errObj['_global'] = _error;
            }

            let descriptionArray: string[] = [];
            Object.keys(errObj).map((key: any) => {
              if (key === '_global') {
                descriptionArray.push(errObj['_global']);
              } else {
                descriptionArray.push(`${key} (${errObj[key]})`);
              }
            });

            let result: LoadDataApiError = {
              message: 'Nastaly chyby při zpracování požadavku',
              description: descriptionArray.join(', '),
              intent: convertIntent(ApiErrorIntent.WARNING, error.errorIntent),
              apiError: _error,
            };

            return result;
          }
          break;
        default:
          {
            let result: LoadDataApiError = {
              message: error.messageTitle || 'Nastala neočekávaná chyba',
              description: error.detailErrors
                ? error.detailErrors.join(', ')
                : undefined,
              intent: convertIntent(ApiErrorIntent.DANGER, error.errorIntent),
              apiError: _error,
            };

            return result;
          }
          break;
      }
    }
  }
}

/**
 * Konverze intent.
 * @param defaultIntent pokuud není určen, bude použit tento
 * @param apiIntent intent z api, nemusí být uveden, pak je použit defaultIntent
 */
const convertIntent = (
  defaultIntent: ApiErrorIntent,
  apiIntent?: ApiErrorIntent
): ApiErrorIntent => {
  if (!apiIntent) {
    return defaultIntent;
  }

  switch (apiIntent) {
    case ApiErrorIntent.WARNING:
      return ApiErrorIntent.WARNING;
    case ApiErrorIntent.DANGER:
      return ApiErrorIntent.DANGER;
    default:
      return defaultIntent;
  }
};
